import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

const initialState = {
	edk: [],
	idk: [],
};

const reducerMap = {
	[types.FETCH_CHANNEL_SUCCESS]: (state, { payload }) => ({
		...state,
		idk: payload.channels,
	}),
	[types.FETCH_EDK_CHANNEL_SUCCESS]: (state, { payload }) => ({
		...state,
		edk: payload.channels,
	}),
};

export default handleActions(reducerMap, initialState);
